/**
 * Starter → StartIntent — the system face's bridge: empty-state heroes
 * and folder-dialog hints construct creation URLs from starter records
 * by feeding this into `getCreateDiagramHref`'s `seed`/`src` opts (the
 * canonical `/f/:id/d/new` assembler).
 */

import type { StartIntent } from '../seeds/startIntent'
import type { Starter } from './Starter'

export function startIntentOf(starter: Starter, src?: string): StartIntent | null {
  const attribution = src ?? `starter:${starter.id}`
  switch (starter.artifact.kind) {
    case 'seed':
      return {
        type: starter.artifact.diagramType,
        seed: { kind: 'sample', id: starter.artifact.seedId },
        src: attribution,
      }
    case 'agent':
      return {
        type: starter.artifact.diagramType,
        seed: { kind: 'agent', prompt: starter.artifact.promptTemplate },
        src: attribution,
      }
    case 'template':
      // Template starters open seedless to the owning domain's picker.
      // The generic editor can still consume `template:` StartIntent seeds,
      // but the starter catalog has no live server-clone route.
      return null
    case 'legacy':
      // Legacy clones open in the legacy app — no StartIntent ride.
      return null
  }
}
